export default {
    "profile": "प्रोफाइल",
    "logout": "बाहेर पडणे",
    "dashboard": "डॅशबोर्ड",
    "password": "पासवर्ड",
    "language": "इंग्रजी",
    "paymentbr": "पेमेंट",
    "subscriptionPaymentMethod": "सदस्यता आणि पेमेंट पद्धत",
    "nothingchanged": "काहीच बदलले नाही",
    "somethingWentWrong": "काहीतरी चूक झाली ! कृपया नंतर पुन्हा प्रयत्न करा",
    "pleaseTryAgainAfterSometime": "कृपया काही वेळाने पुन्हा प्रयत्न करा",
    "noChanges": "बदलले नाही",
    "invalidEmailFormat": "ईमेल स्वरूप अवैध आहे",
    "chooseYourPreferredLanguage": "कृपया तुमची पसंतीची भाषा निवडा.",
    "selectLanguage": "भाषा निवडा",
    "update": "अपडेट करा",
    "languagePreferences": "भाषा प्राधान्ये",
    "packageOf": "चे पॅकेज",
    "satelliteReport": "उपग्रह अहवाल",
    "pastureReport": "कुरण अहवाल",
    "upTo": "इथपर्यंत",
    "animals": "प्राणी",
    "back": "मागे",
    "perMonth": "दर महिन्याला",
    "perYear": "दर वर्षी",
    "continue": "सुरू",
    "changePlan": "योजना बदला",
    "addOn": "ॲड-ऑन",
    "totalPrice": "एकूण किंमत",
    "availableAddOns": "उपलब्ध ॲड-ऑन",
    "next": "पुढे",
    "congratulations": "अभिनंदन",
    "done": "झाले",
    "deforestationComplianceAssessment": "जंगलतोड अनुपालन मूल्यांकन",
    "warning": "चेतावणी",
    "yourDataMightLost": "तुमचा डेटा गमावला जाऊ शकतो.",
    "clickOnSaveBtnMsg": "तुमचा डेटा जतन करण्यासाठी सेव्ह बटणावर क्लिक करा",
    "discardChanges": "बदल जतन करू नका",
    "action": "क्रिया",
    "sendRequest": "विनंती पाठवा",
    "success": "यश",
    "yourRequestSuccessfullySubmitted": "तुमची विनंती यशस्वीरित्या सबमिट केली गेली.",
    "informShortly": "तुमची विनंती यशस्वीरित्या सबमिट केली गेली आहे. तुमचा विश्लेषण अहवाल लवकरच तुम्हाला पाठवला जाईल.",
    "search": "शोधा",
    "pending": "प्रलंबित",
    "approved": "मंजूर",
    "rejected": "नाकारले",
    "primaryGeofence": "प्राथमिक जिओफेन्स",
    "Zero/Negligible Deforestation Probability": "शून्य/नगण्य वनोंच्छेदनाची शक्यता",
    "Low Deforestation Probability": "कमी वनोंच्छेदनाची शक्यता",
    "High Deforestation Probability": "उच्च वनोंच्छेदनाची शक्यता",
    "login": {
        "welcome": "स्वागत आहे! लॉग इन करा",
        "welInfo": "तुमची क्रेडेन्शियल्स एंटर करा.",
        "login": "लॉगिन करा",
        "emailMobile": "ईमेल/मोबाइल",
        "forgotPassword": "पासवर्ड विसरलात",
        "register": "नोंदणी करा",
        "unableToLogin": "लॉग इन करण्यात अक्षम",
        "emailMobileCannotEmpty": "ईमेल/मोबाइल रिक्त असू शकत नाही.",
        "invalidEmailMobileFormat": "अवैध ईमेल/मोबाइल स्वरूप.",
        "passwordCannotEmpty": "पासवर्ड रिक्त असू शकत नाही.",
        "passwordLengthCanlessthan8": "पासवर्डची लांबी ८ वर्णांपेक्षा कमी असू शकत नाही.",
        "email": "ईमेल",
        "phone": "फोन",
        "or": "किंवा",
        "alreadyHaveAccount": "आधीपासूनच एक खाते आहे",
        "loginNow": "आता लॉगिन करा",
        "registerOption": "साइन अप करण्यासाठी एक पर्याय निवडा",
        "signUpWith": "सह साइन अप करा"
    },
    "user": {
        "profileUpdated": "प्रोफाइल यशस्वीरित्या अपडेट केले आहे",
        "profileNotUpdated": "प्रोफाइल अपडेट केलेले नाही",
        "otpSentOnEmail": "OTP यशस्वीरित्या पाठवला गेला!",
        "otpSentSuccessFully": "तुमचा OTP कोड पाठवला होता",
        "unableToVerifyEmail": "ईमेल सत्यापित करण्यात अक्षम",
        "emailCanNotBeEmpty": "ईमेल फील्ड रिक्त करू शकत नाही",
        "firstName": "पहिले नाव",
        "lastName": "आडनाव",
        "email": "ईमेल",
        "mobile": "मोबाईल",
        "currentPassword": "सध्याचा गुप्त शब्द",
        "newPassword": "नवीन पासवर्ड",
        "repeatNewPassword": "नवीन पासवर्डची पुनरावृत्ती करा",
        "firstNameRequired": "नाव आवश्यक आहे.",
        "lastNameRequired": "आडनाव आवश्यक आहे",
        "emailRequired": "ईमेल आवश्यक आहे",
        "onlyAlphabet": "फक्त अक्षरे असू शकतात",
        "notMoreThan15Char": "15 वर्णांपेक्षा जास्त असू शकत नाही",
        "phoneCannotLessThan8Char": "फोन 8 वर्णांपेक्षा कमी असू शकत नाही",
        "countryCodeRequire": "देश कोड आवश्यक आहे",
        "changePassword": "पासवर्ड बदला",
        "goodIdeaToUsePassword": "तुम्ही इतरत्र वापरत नसलेला मजबूत पासवर्ड वापरणे ही चांगली कल्पना आहे.",
        "enterCurrentPassword": "वर्तमान पासवर्ड प्रविष्ट करा",
        "enterNewPassword": "नवीन पासवर्ड टाका",
        "reEnterPassword": "पासवर्ड पुन्हा एंटर करा",
        "pleaseTypeOldPassword": "कृपया जुना पासवर्ड टाइप करा.",
        "pleaseTypeNewPassword": "कृपया नवीन पासवर्ड टाइप करा.",
        "pleaseTypeConfirmPassword": "कृपया पुष्टी पासवर्ड टाइप करा.",
        "passwordChangedSuccesFully": "पासवर्ड यशस्वीरित्या बदलला",
        "passwordDoesNotMatch": "पासवर्ड जुळत नाहीत.",
        "passwordRequired": "पासवर्ड आवश्यक आहे",
        "emailOrPhoneIsRequired": "ईमेल किंवा फोन नंबर आवश्यक आहे"
    },
    "subscription": {
        "subscription": "वर्गणी",
        "membershipPlan": "सदस्यत्व योजना",
        "currentMembershipPlan": "वर्तमान सदस्यत्व योजना",
        "validUpTo": "पर्यंत वैध",
        "viewAllAddOns": "सर्व ॲड-ऑन पहा",
        "renewValidity": "वैधता नूतनीकरण करा",
        "buyNow": "आता खरेदी करा",
        "upgradeMembershipPlan": "सदस्यता योजना अपग्रेड करा",
        "chooseYourMembershipPlan": "तुमची निवडलेली सदस्यत्व योजना",
        "chooseOptionalAddOns": "तुम्ही पर्यायी ॲड-ऑन निवडू शकता",
        "yourSelectedAddons": "तुमचे निवडलेले ॲड-ऑन",
        "addAnotherAddOn": "आणखी एक ॲड-ऑन जोडा",
        "paymentMethod": "पेमेंट पद्धत",
        "addingAPaymentMethod": "पेमेंट पद्धत जोडत आहे",
        "paymentSuccessful": "तुमचे पेमेंट यशस्वी झाले!",
        "weHaveEmailed": "आम्ही तुमच्या पावतीची एक प्रत example@email.com वर ईमेल केली आहे",
        "paymentAuthorizedSuccessfully": "पेमेंट यशस्वीरित्या अधिकृत झाले.",
        "paymentSuccessfulPrompt": "पेमेंट यशस्वी. योजना अपग्रेड केली.",
        "paymentCancelled": "पेमेंट रद्द केले. कृपया पुन्हा प्रयत्न करा."
    },
    "registerFarm": "फार्म रजिस्टर करा",
    "requestDeforestationReport": "जंगलतोड अहवालाची विनंती करा",
    "paymentMenu": "पेमेंट",
    "complianceCertificate": "अनुपालन प्रमाणपत्र",
    "helpDisk": "मदत डिस्क",
    "faqs": "वारंवार विचारले जाणारे प्रश्न",
    "enquiries": "चौकश्या",
    "contactUs": "आमच्याशी संपर्क साधा",
    "payment": {
        "basicPlan": "मूलभूत योजना",
        "advancePlan": "आगाऊ योजना",
        "usdPerMonthPlus": "USD प्रति महिना अधिक",
        "perReport": "प्रति अहवाल",
        "deforestationAnalyticsCertificateDownload": "जंगलतोड विश्लेषण प्रमाणपत्र डाउनलोड"
    },
    "farm": {
        "farmOwnershipType": "शेत मालकीचा प्रकार",
        "licenceNum": "परवाना क्रमांक",
        "viewFarm": "फार्म पहा",
        "stateProvince": "प्रांत/राज्य",
        "postalNumberShouldSimilarToFarm": "घराच्या क्रमांकाप्रमाणेच शेताचा पोस्टल क्रमांक.",
        "videoTutorial": "व्हिडिओ ट्यूटोरियल",
        "clickOnMapMSG": "जिओफेन्सिंग सुरू करण्यासाठी नकाशावर क्लिक करा",
        "prev": "मागील",
        "next": "पुढे",
        "dragVertexMsg": "तुम्ही शिरोबिंदू ड्रॅग देखील करू शकता किंवा उजव्या बाजूला हटवा बटण वापरून ते हटवू शकता. क्लिअर बटण वापरून जिओफेन्स देखील साफ करता येतो",
        "farmAddedSuccessfully": "शेत यशस्वीरित्या जोडले",
        "perimeter": "परिमिती",
        "area": "क्षेत्रफळ",
        "clearGeofence": "जिओफेन्स साफ करा",
        "deleteSelectedVertex": "निवडलेले व्हर्टेक्स हटवा",
        "pleaseStartDrawing": "कृपया नकाशावर जिओफेन्स काढणे सुरू करा.",
        "chooseTheDate": "तारीख निवडा",
        "updateGeofenceForThisFarm": "या फार्मसाठी GEOFENCE अपडेट करा",
        "farmUpdateSuccessfully": "शेत यशस्वीरित्या अद्यतनित केले",
        "farmZone": "फार्म झोन",
        "addNewZones": "नवीन झोन जोडा",
        "zoneName": "झोनचे नाव",
        "addZoneToCreate": "या फार्मसाठी झोन ​​तयार करण्यासाठी कृपया जोन जोन वर क्लिक करा.",
        "noZoneCreated": "अद्याप कोणतेही झोन ​​तयार करण्यात आलेले नाहीत.",
        "searchAndAddPin": "शोधा आणि एक पिन जोडा",
        "zoneNameWillBeHere": "झोनचे नाव येथे असेल",
        "editZone": "झोन संपादित करा",
        "nameOfTheField": "फील्डचे नाव",
        "zoneDetails": "झोन तपशील",
        "addZone": "झोन जोडा",
        "nameOfTheZone": "झोनचे नाव",
        "geofenceIsRequiredToAdd": "झोन जोडण्यासाठी जिओफेन्स आवश्यक आहे. तुमच्या फार्ममध्ये जिओफेन्स तपशील जोडण्यासाठी `फार्म संपादित करा` वर क्लिक करा.",
        "thisFieldApplyHelpText": "जर तुम्ही कोणत्याही सहकारी संस्थेशी संबंधित असाल तरच हे फील्ड तुम्हाला लागू होते (एक सहकारी म्हणजे त्यांच्या सामान्य आर्थिक, सामाजिक आणि सांस्कृतिक गरजा आणि संयुक्त-मालकीच्या आणि लोकशाही-नियंत्रित एंटरप्राइझद्वारे स्वेच्छेने एकत्रित झालेल्या व्यक्तींची स्वायत्त संघटना). जर तुम्ही एखाद्या सहकारी संस्थेशी संबंधित असाल, तर कृपया त्या सहकारी संस्थेचा युनिक आयडेंटिफायर सूचित करा, तो एक नोंदणी किंवा परवाना क्रमांक असू शकतो जो तुम्ही संबद्ध असलेल्या सहकारी संस्थेची ओळख करून देतो.",
        "farmRegistrationID": "फार्म नोंदणी आयडी",
        "farmerName": "शेतकऱ्याचे नाव",
        "farmerRegistrationID": "शेतकरी नोंदणी आयडी",
        "dateOfRequest": "विनंतीची तारीख",
        "status": "स्थिती",
        "address": "पत्ता",
        "save": "जतन करा",
        "farmAddress": "शेताच्या जागेचा पत्ता",
        "corporateName": "कॉर्पोरेट नाव",
        "corporateMailingAddress": "कॉर्पोरेट मेलिंग पत्ता",
        "farmID": "फार्म आयडी",
        "onTheFarm": "शेतावर",
        "userRoles": "वापरकर्ता भूमिका",
        "adduser": "वापरकर्ता जोडा",
        "addAuser": "एक वापरकर्ता जोडा",
        "uploadUsers": "वापरकर्ते अपलोड करा",
        "addNewUser": "नवीन वापरकर्ता जोडा",
        "selectDept": "विभाग निवडा",
        "selectRole": "भूमिका निवडा",
        "editUser": "वापरकर्ता संपादित करा",
        "totalFarms": "एकूण शेततळे",
        "NoAnimalsRegisteredForthisFarm": "या फार्मसाठी कोणत्याही प्राण्यांची नोंदणी केलेली नाही",
        "farmsPerPage": "प्रति पृष्ठ शेततळे",
        "regularFarms": "नियमित शेततळे",
        "farmRegisteredProducts": "फार्म नोंदणीकृत उत्पादने",
        "searchByFarmNameAndId": "फार्मचे नाव आणि आयडी द्वारे शोधा",
        "loadingProductsPleaseWait": "उत्पादने लोड करत आहे... कृपया प्रतीक्षा करा",
        "farmName": "शेताचे नाव",
        "farmLocation": "फार्म स्थान",
        "productName": "उत्पादनाचे नांव",
        "stockStatus": "स्टॉक स्थिती",
        "inStock": "स्टॉक मध्ये",
        "searchByProductName": "उत्पादनाच्या नावाने शोधा",
        "productCategory": "उत्पादन वर्ग",
        "products": "उत्पादने",
        "yourLocationIsDisabled": "तुमचे स्थान अक्षम केले आहे. कृपया डाव्या मेनूमधून तुमचे स्थान शोधा.",
        "close": "बंद",
        "farms": "शेततळे",
        "zones": "झोन",
        "registerAfarm": "फार्मची नोंदणी करा",
        "govtRegistry": "सरकार रजिस्ट्री",
        "cooperativeID": "सहकारी/संघ आयडी",
        "cooperativeName": "सहकारी/संघाचे नाव",
        "farmType": "फार्म प्रकार",
        "contractMating": "कॉन्ट्रॅक्ट वीण",
        "customization": "सानुकूलन",
        "recordsPerpage": "प्रति पृष्ठ रेकॉर्ड",
        "restoreDefault": "डीफॉल्ट पुनर्संचयित करा",
        "apply": "अर्ज करा",
        "CommunityName": "समुहाचे नाव",
        "searchState": "फार्म आयडी, गव्हर्नमेंट रजिस्ट्री, कोऑपरेटिव्ह आयडी, फार्म प्रकार, कॉन्ट्रॅक्ट मॅटिंग द्वारे शोधा",
        "farmOwner": "शेतमालक",
        "govRegistrationNo": "शासकीय नोंदणी क्रमांक",
        "farmInformation": "शेती माहिती",
        "ownershipType": "मालकीचा प्रकार",
        "farmLicenseInformation": "शेती परवाना माहिती",
        "licenseNumber": "परवाना क्रमांक",
        "licenseExpiryDate": "परवाना कालबाह्यता तारीख",
        "regulatorName": "नियामक नाव",
        "regulatorRepresentativeName": "नियामक प्रतिनिधीचे नाव",
        "farmLocationSize": "फार्म स्थान आणि आकार",
        "productionSystem": "शेती प्रणाली",
        "country": "देश",
        "state": "राज्य",
        "city": "गाव/नगर/शहर",
        "farmNumber": "फार्म नंबर",
        "postal": "पोस्टल/पिन कोड",
        "houseNumber": "घर क्रमांक",
        "farmRegistration": "फार्म नोंदणी",
        "cancel": "रद्द करा",
        "register": "नोंदणी करा",
        "ok": "ठीक आहे",
        "totalFarmSize": "एकूण शेताचा आकार",
        "geographicLocation": "भौगोलिक स्थान",
        "farmGeographicLocation": "फार्म भौगोलिक स्थान",
        "perimeterPointLongitude": "परिमिती बिंदू रेखांश",
        "perimeterPointLatitude": "परिमिती बिंदू अक्षांश",
        "perimeterPointLabel": "परिमिती बिंदू लेबल",
        "perimeterLength": "परिमिती लांबी",
        "farmLatitude": "फार्म अक्षांश",
        "farmLongitude": "शेत रेखांश",
        "latitude": "अक्षांश",
        "longitude": "रेखांश",
        "areaUnit": "क्षेत्र युनिट",
        "walkAndMeasure": "चाला आणि मोजा",
        "useGeofenceTool": "जिओफेन्स टूल वापरा",
        "editFarm": "फार्म संपादित करा",
        "update": "अपडेट करा",
        "editAfarm": "शेत संपादित करा",
        "nextFarm": "पुढील शेत",
        "nameoftheFarm": "शेताचे नाव",
        "registerAProduct": " उत्पादनाची नोंदणी करा",
        "farmProducts": "शेती उत्पादने",
        "calf": "वासरू",
        "steer": "वाचा",
        "heifer": "हिफर",
        "sire": "सर",
        "dam": "धरण",
        "registerAnAnimal": "एखाद्या प्राण्याची नोंदणी करा",
        "farmAnimals": "शेतातील प्राणी",
        "farm_type": "फार्म-प्रकार",
        "farm_Owner": "शेतमालक",
        "dateOfRegistration": "नोंदणीची तारीख",
        "dataIsNotAvailableForThisFarm": "या फार्मसाठी डेटा उपलब्ध नाही",
        "registerNewProduct": "नवीन उत्पादनाची नोंदणी करा",
        "information": "माहिती",
        "licenseInfo": "परवाना माहिती",
        "locationInfo": "स्थान माहिती",
        "geoLocation": "भौगोलिक स्थान",
        "perimeterLengthState": "शेताच्या परिमितीची लांबी (कुंपणाची लांबी)",
        "totalFarmSizeState": "शेताचा आकार",
        "productionSystemState": "शेतात वापरलेली उत्पादन प्रणाली",
        "contractMatingState": "कॉन्ट्रॅक्ट मेटिंग प्रोग्रामची संहिता ज्यामध्ये फार्म सहभागी होतात.",
        "ownershipTypeState": "मालकीचा प्रकार",
        "regulatorRepresentativeNameState": "परवाना जारी करणाऱ्या नियामकाचे प्रतिनिधित्व करणाऱ्या व्यक्तीचे नाव",
        "regulatorNameState": "परवाना जारी करणाऱ्या नियामकाचे नाव",
        "licenseExpiryDateState": "वर्तमान परवाना कालबाह्य झाल्याची तारीख",
        "licenseNumberState": "नियामकाने जारी केलेला परवाना क्रमांक",
        "plotNumberState": "शेतातील घर क्रमांक.",
        "plotNumber": "फार्म नंबर",
        "streetStatement": "शेताच्या रस्त्याचे नाव.",
        "cityStatement": "ज्या शहरात शेत आहे.",
        "stateStatement": "देशाचा प्रदेश जिथे शेत आहे.",
        "countryState": "ज्या देशात शेत आहे.",
        "farmStateInfo": "फार्म स्थान पत्ता",
        "perimeterPointLongitudeState": "शेतातील एका बिंदूचे रेखांश.",
        "perimeterPointLatitudeState": "शेतावरील एका बिंदूचे अक्षांश.",
        "perimeterPointLabelState": "बिंदूचे लेबल.",
        "farmLongitudeState": "शेताचा रेखांश.",
        "farmLatitudeState": "शेताचा अक्षांश.",
        "deleteFarm": "फार्म हटवा",
        "corporateRegistrationNum": "कॉर्पोरेट नोंदणी क्रमांक",
        "farmLocationIsRequired": "फार्म स्थान आवश्यक आहे."
    },
    "deforestation": {
        "addZoneToThisFarm": "या फार्ममध्ये झोन जोडा",
        "eudrForestAssessment": "EUDR वन मूल्यांकन",
        "requestEudrForestAssessment": "EUDR वन मुल्यांकनाची विनंती करा",
        "pleaseChooseOption": "कृपया पर्याय निवडा",
        "requestForestReport": "वन अहवाल मागवा",
        "noDeforestationReportMsg": "कोणत्याही जंगलतोड अहवालाची विनंती केलेली नाही. कृपया काही जंगलतोड अहवाल येथे सूचीबद्ध करण्यासाठी विनंती करा.",
        "allCountries": "सर्व देश",
        "allRegions": "सर्व प्रदेश",
        "allFarms": "सर्व शेत",
        "allStatus": "सर्व स्थिती",
        "viewCertificate": "प्रमाणपत्र पहा",
        "requestComplianceCertificate": "अनुपालन प्रमाणपत्राची विनंती करा",
        "assessmentNo": "मूल्यांकन क्र",
        "blockchainCertificationInfo": "प्रमाणपत्र स्वीकारल्यानंतर ब्लॉकचेन प्रमाणपत्र प्रमाणीकरण हॅश उपलब्ध होईल",
        "blockchainCertificationValidation": "ब्लॉकचेन प्रमाणपत्र प्रमाणीकरण",
        "openBlockchainPage": "ब्लॉकचेन पृष्ठ उघडा",
        "clickOnAboveLink": "ब्लॉकचेनवर प्रमाणपत्र प्रमाणित करण्यासाठी वरील लिंकवर क्लिक करा",
        "shareCertificate": "प्रमाणपत्र शेअर करा",
        "high": "उच्च",
        "low": "कमी",
        "zeroOrNegigible": "शून्य किंवा नगण्य",
        "deforestationProbability": "जंगलतोड संभाव्यता",
        "colorCode": "रंग कोड",
        "geofenceAarea": "जिओफेन्स क्षेत्र",
        "percentageOfGeofenceArea": "जिओफेन्स क्षेत्राची टक्केवारी",
        "overallDeforestationProbability": "एकूणच जंगलतोड संभाव्यता",
        "deforestationComplianceReport": "जंगलतोड अनुपालन अहवाल",
        "noDeforestationComplianceReport": "जंगलतोड अनुपालन eReport आढळले नाही",
        "loadingDeforestationComplianceReport": "जंगलतोड अनुपालन ई-रिपोर्ट लोड करत आहे",
        "farmRegistrationId": "फार्म नोंदणी आयडी",
        "farmerName": "शेतकऱ्याचे नाव",
        "farmerRegistrationId": "शेतकरी नोंदणी आयडी",
        "uniqueFarmerId": "युनिक शेतकरी आयडी",
        "uniqueFarmId": "युनिक फार्म आयडी",
        "farmLocation": "फार्म स्थान",
        "area": "क्षेत्रफळ",
        "farmAddress": "शेताचा पत्ता",
        "dateOfRequest": "विनंतीची तारीख",
        "status": "स्थिती",
        "settings": "सेटिंग्ज",
        "assignmentIssued": "असाइनमेंट जारी केले",
        "certificateIssued": "प्रमाणपत्र जारी केले",
        "complianceCertification": "अनुपालन प्रमाणन",
        "noComplianceCertification": "कोणतेही अनुपालन प्रमाणपत्र आढळले नाही",
        "loadingComplianceCertification": "अनुपालन प्रमाणपत्र लोड करत आहे",
        "assessmentReport": "मूल्यांकन अहवाल",
        "downloadPDF": "PDF डाउनलोड करा",
        "print": "छापा",
        "back": "मागे",
        "farmDetails": "फार्म तपशील",
        "dimitraFarmId": "दिमित्रा फार्म आयडी",
        "dimitraFermerId": "दिमित्रा शेतकरी आयडी",
        "totalGeofenceAreaHA": "एकूण जिओफेन्स क्षेत्र (HA)",
        "forestLossHA": "वन नुकसान (HA)",
        "forestGainHA": "फॉरेस्ट गेन (HA)",
        "forestUnchangedHA": "फॉरेस्ट अपरिवर्तित (HA)",
        "forestUnchanged": "जंगल अपरिवर्तित",
        "forestLoss": "जंगलाचे नुकसान",
        "forestGain": "वन लाभ",
        "totalGeofenceArea": "एकूण जिओफेन्स क्षेत्र",
        "forestAssessmentHelp": "तुम्हाला या अहवालाबद्दल प्रश्न असल्यास किंवा ते समजून घेण्यासाठी मदत हवी असल्यास, हेल्प डेस्कद्वारे आमच्याशी संपर्क साधा.",
        "allReport": "सर्व अहवाल",
        "deforestationRepot": "जंगलतोड अहवाल",
        "requestDeforestationReportNow": "आता जंगलतोड अहवालाची विनंती करा",
        "noRecordFound": "कोणतेही रेकॉर्ड आढळले नाही",
        "noDeforestationReportRequested": "कोणत्याही जंगलतोड अहवालाची विनंती केलेली नाही. कृपया काही जंगलतोड अहवाल येथे सूचीबद्ध करण्यासाठी विनंती करा.",
        "deforestationImage": "जंगलतोड प्रतिमा",
        "reqDeforestationReport": "जंगलतोड अहवालाची विनंती करा",
        "confirm": "पुष्टी",
        "newForestArea": "नवीन वनक्षेत्र",
        "deforestedArea": "जंगलतोड केलेले क्षेत्र",
        "existingForestArea": "विद्यमान वनक्षेत्र",
        "deforestation": "जंगलतोड",
        "farmName": "शेताचे नाव",
        "location": "स्थान",
        "dateOfInterest": "व्याजाची तारीख",
        "geofenceArea": "GeofenceArea (HA)",
        "deforestationArea": "जंगलतोड क्षेत्र (HA)",
        "treeGainArea": "ट्री गेन एरिया (HA)",
        "currentForestArea": "सध्याचे वनक्षेत्र (HA)",
        "view": "पहा",
        "locationInfoRequired": "स्थान माहिती आवश्यक आहे",
        "geofenceNameRequired": "जिओफेन्स नाव आवश्यक आहे",
        "futureDateSelected": "भविष्यातील तारीख निवडली",
        "reportGeneratedSuccessfully": "अहवाल यशस्वीरित्या व्युत्पन्न झाला",
        "reportCannotAdded": "अहवाल जोडला जाऊ शकत नाही.",
        "primaryFarmNotFound": "प्राथमिक शेत सापडले नाही.",
        "pleaseRegisterFarmFirst": "कृपया प्रथम शेताची नोंदणी करा"
    },
    "certificate": {
        "allCertificate": "सर्व प्रमाणपत्रे",
        "certificate": "प्रमाणपत्र"
    }
}